<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="标准名称" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.standard_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="标准编号">
            <template slot-scope="scope">
              {{ scope.row.standard_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="标准级别">
            <template slot-scope="scope">
              {{ scope.row.standard_level || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="标准类别">
            <template slot-scope="scope">
              {{ scope.row.standard_category || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="起草人" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.principal_drafter || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="起草单位" min-width="230">
            <template slot-scope="scope">
              {{ scope.row.draft_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="执行单位">
            <template slot-scope="scope">
              {{ scope.row.execution_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="发布日期">
            <template slot-scope="scope">
              {{ scope.row.release_date || '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'standardList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '标准信息',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>